import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Standard layout for list pages: optional toolbar row (start + actions) + full-width filters.
 *
 * Usage:
 * <lib-table-filter-panel>
 *   <div tableFilterStart>…tablar / sarlavha (filtr emas)</div>
 *   <div tableFilterActions>…Yaratish, Export (panel header — filtr tugmasi bilan bir balandlik)</div>
 *   <lib-table-filter [fields]="fields">…barcha API filtrlari shu yerda</lib-table-filter>
 * </lib-table-filter-panel>
 */
@Component({
  selector: 'lib-table-filter-panel',
  standalone: true,
  template: `
    <section class="lib-table-filter-panel">
      <header class="lib-table-filter-panel__header">
        <div class="lib-table-filter-panel__start">
          <ng-content select="[tableFilterStart]" />
        </div>
        <div class="lib-table-filter-panel__actions">
          <ng-content select="[tableFilterActions]" />
        </div>
      </header>
      <div class="lib-table-filter-panel__filters">
        <ng-content />
      </div>
    </section>
  `,
  styleUrl: './table-filter-panel.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableFilterPanelComponent {}
